import * as ko from "knockout";
import {TBaseOrObservableOrFunctionType} from "../index";

export function isNullOrUndefined(val: any): boolean {
    return val === null || val === undefined
}

export function isNullOrUndefinedOrEmptyString(val: any): boolean {
    return isNullOrUndefined(val) || val === ''
}

export function getAnyValue<T = any>(obj: TBaseOrObservableOrFunctionType<T>): T {
    let ret: any = obj
    if (ko.isObservable(ret)) {
        ret = ko.unwrap(ret)
        return getAnyValue(ret)
    }
    if (typeof ret === 'function') {
        return getAnyValue(ret())
    }
    return ret
}
